var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24V30.8C28 31.9201 28 32.4798 28.218 32.9076C28.4097 33.2839 28.7155 33.5905 29.0918 33.7822C29.5192 34 30.079 34 31.1969 34H34.8031C35.921 34 36.48 34 36.9074 33.7822C37.2837 33.5905 37.5905 33.2837 37.7822 32.9074C38 32.48 38 31.921 38 30.8031V27.1969C38 26.079 38 25.5192 37.7822 25.0918C37.5905 24.7155 37.2839 24.4097 36.9076 24.218C36.4798 24 35.9201 24 34.8 24H28ZM28 24V20C28 16.6863 30.6863 14 34 14M10 24V30.8C10 31.9201 10 32.4798 10.218 32.9076C10.4097 33.2839 10.7155 33.5905 11.0918 33.7822C11.5192 34 12.079 34 13.1969 34H16.8031C17.921 34 18.48 34 18.9074 33.7822C19.2837 33.5905 19.5905 33.2837 19.7822 32.9074C20 32.48 20 31.921 20 30.8031V27.1969C20 26.079 20 25.5192 19.7822 25.0918C19.5905 24.7155 19.2839 24.4097 18.9076 24.218C18.4798 24 17.9201 24 16.8 24H10ZM10 24V20C10 16.6863 12.6863 14 16 14",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.609dc279f83f65d7b89d63145d6efbb7.svg";
export { ForwardRef as ReactComponent };